export const EMAIL_STATUS_COLOR: Record<string, string> = {
  // Outreach (BulkEmailItemStatus) values — lowercase per the enum definition.
  sent: 'green',
  failed: 'red',
  pending: 'yellow',
  sending: 'blue',
  unknown: 'orange',
  skipped: 'gray',
  processing: 'blue',
  completed: 'green',
  // Resend webhook statuses (flow emails).
  delivered: 'green',
  opened: 'teal',
  clicked: 'purple',
  bounced: 'red',
  complained: 'red',
};
